(function () {
  function updateFooterMenus() {
    var mobile = window.matchMedia('(max-width: 750px)').matches;
    document.querySelectorAll('.gielle-footer__details').forEach(function (item) {
      if (item.dataset.gielleViewport !== (mobile ? 'mobile' : 'desktop')) {
        item.open = !mobile;
        item.dataset.gielleViewport = mobile ? 'mobile' : 'desktop';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFooterMenus);
  } else {
    updateFooterMenus();
  }
  window.addEventListener('resize', updateFooterMenus, { passive: true });
  document.addEventListener('shopify:section:load', updateFooterMenus);
})();
